<template>
  <footer>
    <div class="container">
      <div class="inner-footer">
        <div>
          <small class="font-weight-bold">Powered By:</small>
        </div>
        <div class="mx-1">
          <img
            width="42px"
            src="@/assets/otm-logo-footer.svg"
            alt=""
          >
        </div>
        <a
          class="font-weight-light"
          href="https://onthemapmarketing.com"
          target="_blank"
        >OnTheMapMarketing.com</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scoped>
  footer {
    background-color: transparent;

    .inner-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      border-top: 1px solid #D1D1D1;
    }

    a {
      color: #000;
    }
  }
</style>
